import { useCallback, useEffect } from 'react';
import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useLazySearchAccountantEmissorContractBeneficiariesQuery, useLazySearchClientEmissorContractBeneficiariesQuery, } from '../services/contractBeneficiariesApi';
const EMPTY_BENEFICIARIES = [];
export function useEmissorContractCollaborators({ contractId, enabled = true, }) {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const shouldSkip = !enabled || !contractId;
    const [triggerAccountant, accountantState] = useLazySearchAccountantEmissorContractBeneficiariesQuery();
    const [triggerClient, clientState] = useLazySearchClientEmissorContractBeneficiariesQuery();
    const trigger = isAccountant ? triggerAccountant : triggerClient;
    const state = isAccountant ? accountantState : clientState;
    const fetchCollaborators = useCallback(() => {
        if (shouldSkip || !contractId) {
            return;
        }
        trigger({ contractId, body: {} });
    }, [contractId, shouldSkip, trigger]);
    useEffect(() => {
        fetchCollaborators();
    }, [fetchCollaborators]);
    return {
        beneficiaries: state.data?.result ?? EMPTY_BENEFICIARIES,
        total: state.data?.total ?? 0,
        isLoading: state.isLoading || state.isFetching,
        isError: state.isError,
        refetch: fetchCollaborators,
    };
}
